// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__1Tf8o","error":"Textarea_error__1FwzV","readonly":"Textarea_readonly__2CYW-","disabled":"Textarea_disabled__1Ndqm"};